import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import React from 'react';
import SingleFlag from "./SingleFlag";
import { FlagsWrapper } from "./style";
var RequirementFlags = function RequirementFlags(_ref) {
  var flags = _ref.flags,
    otherFlags = _ref.otherFlags,
    flagsAtBottom = _ref.flagsAtBottom;
  return /*#__PURE__*/React.createElement(FlagsWrapper, {
    flagsAtBottom: flagsAtBottom
  }, flags.map(function (flag) {
    return /*#__PURE__*/React.createElement(SingleFlag, {
      key: flag.flagName,
      flag: flag.flagName,
      toolTipMsg: flag.toolTipMsg
    });
  }), otherFlags && Object.keys(otherFlags).map(function (flag) {
    return /*#__PURE__*/React.createElement(SingleFlag, {
      key: flag,
      flag: flag,
      toolTipMsg: otherFlags[flag]
    });
  }));
};
export default RequirementFlags;